import * as React from "react";
import { EventCategory } from "../../../utils/analytics";
import { buildCoinUrl } from "../../../utils/build-url";
import Image from "../../ui-library/image/image";
import Link from "../../ui-library/link/link";
import styles from "./coin-tickers-table.styles";

interface CoinCellProps {
  slug?: string;
  name?: string;
  image?: string;
  symbol?: string;
  rank: number;
  eventCategory: EventCategory;
}

const CoinCell: React.FC<CoinCellProps> = ({
  slug,
  name,
  rank,
  image,
  symbol,
  eventCategory,
}) => (
  <Link
    css={styles.nameContainer}
    to={buildCoinUrl(slug!)}
    analytics={{
      category: eventCategory,
      action: "Click - Coin url",
      label: name || "",
    }}
  >
    <div css={styles.nameColLeft}>
      <div css={styles.imageContainer}>
        <Image src={image} css={styles.image} alt="logo" />
      </div>
      <div css={styles.nameColRank}>{rank}</div>
    </div>
    <div>
      <div css={styles.name}>{name}</div>
      <div css={styles.type}>{symbol?.toUpperCase()}</div>
    </div>
  </Link>
);

export default CoinCell;
